//import main modules here
import Vue from 'vue'
import moment from 'moment';
import App from './App.vue'
import router from './router';
import store from './store/index';
import BootstrapVue from "bootstrap-vue";
import PrimeVue from './primevue';
import LoadingBars from './components/LoadingBars';
import LoadingArete from './components/LoadingArete';
import LoginLoadingArete from './components/LoginLoadingArete';
import VueClipboard from 'vue-clipboard2'

//font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import './assets/layout/layout.scss';
library.add(faCode);
Vue.use(BootstrapVue);
Vue.use(VueClipboard);
Vue.component("primevue", PrimeVue);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('Loading', LoadingBars);
Vue.component('LoadingArete', LoadingArete);
Vue.component('LoginLoadingArete', LoginLoadingArete);

Vue.filter("formatDateTime", value => {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("formatStatus", value => {
  // console.log(value)
  if (value == true) {
    return 'Active'
  } else {
    return 'InActive'
  }
});



Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
